var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{on:{"click":_vm.start}},[_vm._v("start")]),_c('el-button',{on:{"click":_vm.stop}},[_vm._v("stop")]),_c('video',{attrs:{"id":"testVideo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }